module.exports = __webpack_public_path__ + "assets/img/b6556e93c8f546c7ecbcc06f88ee5462.png";